import React, { useCallback, useEffect, useState } from 'react';
import styles from './Reply.module.less';
import dayjs from 'dayjs';
import Tag from './Tag';
import Preview from '../../Preview/Preview';
import { formatNumber } from '../../../utils/utils';
import UserHeader from '../../../static/forum_default_header.svg';
import config from '../config';
import useLoginStatus, { handleLogin } from '../../../utils/hooks/useLoginStatus';
import CommentOn from '../../CommentOn';
import V from '../../../static/comment_v.svg';
import Guan from '../../../static/comment_guan.svg';
import { Popover } from 'antd';
import getChildrenJSON from '../getChildrenJSON';
import getHtmlByNodeList from '../getHtmlByNodeList';
import Report from './Report';
import { logging } from '../../../actions/log';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Toast from '../../Toast/Toast';
import VSmall from '../../../static/comment_v_small.svg';
import GuanSmall from '../../../static/comment_guan_small.svg';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default ({
  comment = {},
  commentInfo,
  data,
  handleUpdate,
  requestInfo,
  releaseInfo,
  handleUpdateByEditor,
  updateCommentOn,
  currCommentOn,
  commentTargetInfo,
}) => {
  const [previewInfo, setPreviewInfo] = useState({ show: false, active: 0 });
  const [replyUser, setReplyUser] = useState('');
  const loginStatus = useLoginStatus();
  const [hasTask, setHasTask] = useState(false);
  const [showCommentOn, setShowCommentOn] = useState(false);
  const [node, setNode] = useState(null);
  const [replyContent, setReplyContent] = useState(comment?.contentInfo?.text);
  const [commentDetail, setCommentDetail] = useState(null);
  const [showReport, setShowReport] = useState(false);
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const requestZan = useCallback(async () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Detail_CommmentZan',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id: requestInfo?.bizIdentity,
          commmentId: commentInfo?.id,
          replyId: comment?.id,
          id: requestInfo?.bizIdentity?.replace('zt_', ''),
          version: requestInfo?.version,
          type: requestInfo?.type,
        },
      }),
    );
    setHasTask(false);
    try {
      const res = await config.setCommentZan({
        bizIdentity: data?.bizIdentity,
        optType: '2',
        type: data?.type,
        commentId: commentInfo?.id,
        targetUserId: comment?.userId,
        replyId: comment.id,
      });
      if (res?.status == 0) {
        handleUpdate(res?.data);
      }
      if (res?.status == '200201') {
        handleUpdate({
          commentId: commentInfo?.id,
          zanCount: comment?.datas.zan,
          replyId: comment?.id,
        });
      }
    } catch (err) {
      //
    }
  }, [data, commentInfo, comment]);

  const handleZan = useCallback(() => {
    if (comment.hasZan === 1) {
      Toast.error({
        content: '您已经点过赞了',
      });
      return;
    }
    if (!loginStatus) {
      setHasTask(true);
      handleLogin();
    } else {
      requestZan();
    }
  }, [data, commentInfo, comment, loginStatus]);

  const handleUser = useCallback(
    json => {
      const temp = json.map(el => {
        if (el?.attrs && el?.attrs[0]?.name == 'data-user') {
          const target = releaseInfo?.mentionUsers?.find(
            item => item.userId === el?.attrs[0]?.value,
          );
          return {
            ...el,
            children: target?.nickName ? [`@${target.nickName}`] : el.children,
          };
        }
        return el;
      });

      return temp;
    },
    [releaseInfo],
  );

  const handleReport = useCallback(() => {
    setShowReport(true);
    dispatch(
      logging({
        category: 'C',
        action: 'Comment_Report',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id: requestInfo?.bizIdentity?.replace('zt_', ''),
          version: requestInfo?.version,
          type: requestInfo?.type,
        },
      }),
    );
  }, [comment]);

  const handleLogComment = useCallback(
    clickType => () => {
      dispatch(
        logging({
          category: 'C',
          action: 'Comment_Content',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: requestInfo.type,
            clickType,
            id: requestInfo?.bizIdentity?.replace('zt_', ''),
            version: requestInfo?.version,
          },
          // param3: data.bizInfo,
        }),
      );
    },
    [],
  );

  useEffect(() => {
    try {
      const temp = comment?.contentInfo?.text ? decodeURIComponent(comment?.contentInfo?.text) : '';
      if (temp && temp.indexOf('@') > -1) {
        const content = temp?.replace('@', '');
        const index = content.indexOf(':');
        if (commentInfo?.id !== comment.parentId) {
          setReplyUser(content?.slice(0, index));
        }
        setReplyContent(content?.slice(index + 1));
      }
    } catch (err) {}
  }, [comment?.contentInfo?.text]);

  useEffect(() => {
    try {
      const content = replyContent ? replyContent?.split('\n').join('<br/>') : '';
      const contentNode = document.createElement('div');
      contentNode.innerHTML = content;
      const json = getChildrenJSON(contentNode);
      const newJson = handleUser(json);
      setCommentDetail(getHtmlByNodeList(newJson)?.elems[0].innerHTML);
    } catch (err) {}
  }, [replyContent]);

  useEffect(() => {
    if (loginStatus && hasTask) {
      handleZan();
    }
  }, [loginStatus, hasTask]);
  if (
    !commentDetail &&
    comment?.contentInfo?.imgs?.length === 0 &&
    [...(comment?.contentInfo?.appList || []), ...(comment?.contentInfo?.specialList || [])]
      .length === 0
  ) {
    return null;
  }

  return (
    <>
      <div ref={r => setNode(r)}>
        <div className={`${styles.child_comment}`}>
          <div className={styles.child_comment_left}>
            <div className={styles.child_comment_img}>
              <img
                src={comment?.profilePicUrl || UserHeader}
                className={styles.child_comment_img}
              />
              {comment?.identity?.type && (
                <>
                  {comment?.identity?.type === 1 && (
                    <img src={GuanSmall} className={styles.child_comment_img_v} />
                  )}
                  {comment?.identity?.type === 3 && (
                    <img src={VSmall} className={styles.child_comment_img_v} />
                  )}
                </>
              )}
            </div>

            <div className={styles.user_container}>
              <div className={styles.user}>
                <label title={comment.nickName.length > 10 ? comment.nickName : ''}>{comment.nickName || '商店用户'}</label>

                {comment.parentId !== commentInfo.id && (
                  <>
                    {replyUser && '  回复  '}
                    {replyUser ? <label>{replyUser}</label> : ''}
                  </>
                )}
              </div>

              <div className={styles.reply_time}>
                {comment.updateTime ? dayjs(comment.updateTime).format('YYYY-MM-DD HH:mm') : '刚刚'}
              </div>
            </div>
          </div>
          <div className={styles.child_comment_right}>
            {releaseInfo?.commentSwitch === 0 && (
              <div className={styles.comment_opt}>
                {/* <div className={styles.comment_opt_item} onClick={handleReport}>
                  <i className={`${styles.comment_opt_cion} iconfont  icon-jubao`} />
                  <div className={styles.comment_opt_num}>举报</div>
                </div> */}
                <div
                  className={styles.comment_opt_item}
                  onClick={() => {
                    handleZan();
                  }}
                >
                  <span
                    className={`${styles.comment_opt_cion} iconfont ${
                      comment.hasZan === 1 ? styles.comment_opt_cion_active : ''
                    } ${comment.hasZan === 1 ? styles.comment_opt_cion_zaned : 'icon-dianzan '}`}
                  />
                  <div
                    className={`${styles.comment_opt_num} ${
                      comment.hasZan === 1 ? styles.comment_opt_num_active : ''
                    }`}
                  >
                    {comment?.datas?.zan ? formatNumber(comment?.datas?.zan || 0) : '赞'}
                  </div>
                </div>
                <div
                  className={styles.comment_opt_item}
                  onClick={() => {
                    if (releaseInfo?.forbidden) {
                      Toast.error({
                        content: '您的账号已被禁言',
                      });
                      return;
                    }
                    if (!loginStatus) {
                      handleLogin();
                      return;
                    }
                    setShowCommentOn(true);
                    updateCommentOn({
                      commentInfo,
                      replyInfo: comment,
                    });
                  }}
                >
                  <i className={`${styles.comment_opt_cion} iconfont icon-pinglun`} />
                  <div className={styles.comment_opt_num}>回复</div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.content_container}>
          {commentDetail && (
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: commentDetail || '' }}
            />
          )}

          {comment?.contentInfo?.imgs?.length > 0 && (
            <div className={styles.content_imgs}>
              {comment?.contentInfo?.imgs?.map((item, index) => (
                <img
                  src={item}
                  key={index}
                  onClick={() => {
                    handleLogComment('img')();
                    setPreviewInfo({
                      ...previewInfo,
                      show: true,
                      active: index,
                    });
                  }}
                />
              ))}
            </div>
          )}
        </div>

        {[...(comment?.contentInfo?.appList || []), ...(comment?.contentInfo?.specialList || [])]
          .length > 0 && (
          <div className={styles.tag}>
            {[
              ...(comment?.contentInfo?.appList || []),
              ...(comment?.contentInfo?.specialList || []),
            ].map((item, index) => (
              <div
                className={styles.tag_detail}
                key={index}
                onClick={handleLogComment(item.ztId ? 'zt' : 'soft')}
              >
                <Tag data={item} type={item.ztId ? 'zt' : 'soft'} />
              </div>
            ))}
          </div>
        )}
      </div>
      {showCommentOn &&
        currCommentOn?.replyInfo?.id === comment?.id &&
        currCommentOn?.commentInfo?.id === commentInfo?.id && (
          <div className={styles.comment_editor}>
            <CommentOn
              commentInfo={commentInfo} //评论
              hasScore={false}
              requestInfo={requestInfo}
              releaseInfo={releaseInfo}
              replyInfo={comment} //回复
              handleUpdate={data => {
                if (data) {
                  handleUpdateByEditor(data, commentInfo?.id, 'reply', comment?.id);
                }
                setShowCommentOn(false);
              }}
              commentTargetInfo={commentTargetInfo}
            />
          </div>
        )}
      {previewInfo.show && (
        <Preview
          data={comment?.contentInfo?.imgs?.map(item => ({ url: item, type: '0' }))}
          visible={true}
          activeIndex={previewInfo.active}
          close={() => {
            setPreviewInfo({ ...previewInfo, show: false });
          }}
        />
      )}
      {showReport && (
        <Report
          handleCancel={() => {
            setShowReport(false);
          }}
          releaseInfo={releaseInfo}
          commentInfo={commentInfo}
          replyInfo={comment}
          requestInfo={requestInfo}
        />
      )}
    </>
  );
};
